// src/assets/svgs/icons.jsx
import React from "react";

export const FacebookIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_34444_3372)">
      <path
        d="M16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 11.993 2.92547 15.3027 6.75 15.9028V10.3125H4.71875V8H6.75V6.2375C6.75 4.2325 7.94438 3.125 9.77172 3.125C10.6467 3.125 11.5625 3.28125 11.5625 3.28125V5.25H10.5538C9.56 5.25 9.25 5.86672 9.25 6.5V8H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.993 16 8Z"
        fill="#1877F2"
      />
      <path
        d="M11.1141 10.3125L11.4688 8H9.25V6.5C9.25 5.86734 9.56 5.25 10.5538 5.25H11.5625V3.28125C11.5625 3.28125 10.647 3.125 9.77172 3.125C7.94438 3.125 6.75 4.2325 6.75 6.2375V8H4.71875V10.3125H6.75V15.9028C7.5783 16.0324 8.4217 16.0324 9.25 15.9028V10.3125H11.1141Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_34444_3372">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const VideoIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="18"
    viewBox="0 0 24 18"
    fill="none"
  >
    <path
      d="M16.7926 4.71101C17 5.67676 17 6.97075 17 9C17 11.0287 17 12.3225 16.7928 13.2882M16.7926 4.71101C16.7138 4.34408 16.6051 4.02453 16.455 3.73005C15.9757 2.78924 15.2108 2.02433 14.27 1.54497C13.2004 1 11.8003 1 9 1C6.19974 1 4.79961 1 3.73005 1.54497C2.78924 2.02433 2.02433 2.78924 1.54497 3.73005C1 4.79961 1 6.19974 1 9C1 11.8003 1 13.2004 1.54497 14.27C2.02433 15.2108 2.78924 15.9757 3.73005 16.455C4.79961 17 6.19974 17 9 17C11.8003 17 13.2004 17 14.27 16.455C15.2108 15.9757 15.9757 15.2108 16.455 14.27C16.6052 13.9753 16.714 13.6555 16.7928 13.2882M16.7926 4.71101L17 4.62176L17.3984 4.44768C19.9262 3.34311 21.1902 2.79083 22.0951 3.38296C23 3.97508 23 5.3544 23 8.11304V9.88696C23 12.6456 23 14.0249 22.0951 14.617C21.1902 15.2092 19.9262 14.6569 17.3984 13.5523L17 13.3782L16.7928 13.2882M6 9C6 7.21423 6 6.32135 6.35181 5.80519C6.65868 5.35497 7.13034 5.06469 7.64955 5.00652C8.24481 4.93983 8.97022 5.38627 10.4211 6.27915C11.8719 7.17204 12.5973 7.61848 12.8407 8.20133C13.0531 8.70972 13.0531 9.29028 12.8407 9.79867C12.5973 10.3815 11.8719 10.828 10.4211 11.7208C8.97022 12.6137 8.24481 13.0602 7.64955 12.9935C7.13034 12.9353 6.65868 12.645 6.35181 12.1948C6 11.6786 6 10.7858 6 9Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const TwitterIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_34444_3375)">
      <g clipPath="url(#clip1_34444_3375)">
        <path
          d="M12.6411 0.746582H15.0936L9.70876 6.87992L16 15.1999H11.063L7.1976 10.1439L2.77241 15.1999H0.319893L6.02466 8.63992L0 0.746582H5.05965L8.55182 5.36525L12.6411 0.746582ZM11.7827 13.7599H13.1423L4.34522 2.13325H2.88437L11.7827 13.7599Z"
          fill="black"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_34444_3375">
        <rect width="16" height="16" fill="white" />
      </clipPath>
      <clipPath id="clip1_34444_3375">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const InstagramIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_34444_3378)">
      <path
        d="M12.3108 0H3.68916C1.65169 0 0 1.65169 0 3.68916V12.3108C0 14.3483 1.65169 16 3.68916 16H12.3108C14.3483 16 16 14.3483 16 12.3108V3.68916C16 1.65169 14.3483 0 12.3108 0Z"
        fill="url(#paint0_linear_34444_3378)"
      />
      <path
        d="M10.5802 3.15647C11.1876 3.15892 11.7695 3.40129 12.1989 3.83079C12.6284 4.26029 12.8708 4.84211 12.8733 5.44951V10.5503C12.8708 11.1577 12.6284 11.7395 12.1989 12.169C11.7695 12.5985 11.1876 12.8409 10.5802 12.8433H5.4196C4.81221 12.8409 4.23038 12.5985 3.80088 12.169C3.37138 11.7395 3.12901 11.1577 3.12657 10.5503V5.44951C3.12901 4.84211 3.37138 4.26029 3.80088 3.83079C4.23038 3.40129 4.81221 3.15892 5.4196 3.15647H10.5802ZM10.5802 2.08994H5.4196C3.57176 2.08994 2.05969 3.60373 2.05969 5.44985V10.5503C2.05969 12.3981 3.57348 13.9102 5.4196 13.9102H10.5802C12.4281 13.9102 13.9401 12.3964 13.9401 10.5503V5.44951C13.9401 3.60166 12.4281 2.0896 10.5802 2.0896V2.08994Z"
        fill="white"
      />
      <path
        d="M8 6.00891C8.39378 6.00891 8.77871 6.12568 9.10613 6.34445C9.43354 6.56322 9.68873 6.87417 9.83942 7.23797C9.99011 7.60177 10.0295 8.00209 9.95272 8.3883C9.8759 8.77451 9.68627 9.12927 9.40783 9.40771C9.12939 9.68615 8.77463 9.87577 8.38842 9.95259C8.00221 10.0294 7.6019 9.98999 7.23809 9.8393C6.87429 9.6886 6.56334 9.43342 6.34457 9.106C6.1258 8.77859 6.00904 8.39366 6.00904 7.99988C6.00967 7.47204 6.21964 6.966 6.59288 6.59276C6.96612 6.21952 7.47216 6.00955 8 6.00891ZM8 4.94238C7.39529 4.94238 6.80415 5.1217 6.30135 5.45766C5.79855 5.79363 5.40666 6.27114 5.17524 6.82983C4.94383 7.38851 4.88328 8.00327 5.00126 8.59637C5.11923 9.18947 5.41043 9.73426 5.83803 10.1619C6.26563 10.5895 6.81042 10.8807 7.40352 10.9986C7.99661 11.1166 8.61137 11.0561 9.17006 10.8246C9.72874 10.5932 10.2063 10.2013 10.5422 9.69854C10.8782 9.19573 11.0575 8.6046 11.0575 7.99988C11.0575 7.18898 10.7354 6.4113 10.162 5.8379C9.58859 5.26451 8.8109 4.94238 8 4.94238Z"
        fill="white"
      />
      <path
        d="M11.1243 5.53329C11.5247 5.53329 11.8492 5.20874 11.8492 4.80839C11.8492 4.40804 11.5247 4.0835 11.1243 4.0835C10.724 4.0835 10.3994 4.40804 10.3994 4.80839C10.3994 5.20874 10.724 5.53329 11.1243 5.53329Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_34444_3378"
        x1="10.4864"
        y1="16.6716"
        x2="5.51361"
        y2="-0.67157"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFDB73" />
        <stop offset="0.08" stopColor="#FDAD4E" />
        <stop offset="0.15" stopColor="#FB832E" />
        <stop offset="0.19" stopColor="#FA7321" />
        <stop offset="0.23" stopColor="#F6692F" />
        <stop offset="0.37" stopColor="#E84A5A" />
        <stop offset="0.48" stopColor="#E03675" />
        <stop offset="0.55" stopColor="#DD2F7F" />
        <stop offset="0.68" stopColor="#B43D97" />
        <stop offset="0.97" stopColor="#4D60D4" />
        <stop offset="1" stopColor="#4264DB" />
      </linearGradient>
      <clipPath id="clip0_34444_3378">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const LinkedInIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_34444_3384)">
      <path
        d="M14.8189 0H1.18111C0.867861 0 0.567441 0.124438 0.34594 0.34594C0.124438 0.567441 0 0.867861 0 1.18111V14.8189C0 15.1321 0.124438 15.4326 0.34594 15.6541C0.567441 15.8756 0.867861 16 1.18111 16H14.8189C15.1321 16 15.4326 15.8756 15.6541 15.6541C15.8756 15.4326 16 15.1321 16 14.8189V1.18111C16 0.867861 15.8756 0.567441 15.6541 0.34594C15.4326 0.124438 15.1321 0 14.8189 0ZM4.76889 13.63H2.36333V5.98889H4.76889V13.63ZM3.56445 4.93C3.29158 4.92846 3.02528 4.84613 2.79916 4.69339C2.57304 4.54065 2.39723 4.32435 2.29392 4.07179C2.19061 3.81923 2.16443 3.54173 2.21869 3.2743C2.27294 3.00688 2.4052 2.76152 2.59877 2.56919C2.79234 2.37686 3.03854 2.24618 3.30631 2.19364C3.57408 2.1411 3.85141 2.16906 4.1033 2.27399C4.35519 2.37892 4.57036 2.55611 4.72164 2.78321C4.87293 3.01031 4.95355 3.27713 4.95333 3.55C4.95591 3.73269 4.92167 3.91403 4.85267 4.0832C4.78368 4.25238 4.68132 4.40593 4.55171 4.53471C4.42211 4.66349 4.2679 4.76486 4.09828 4.83277C3.92867 4.90068 3.74711 4.93375 3.56445 4.93ZM13.6356 13.6367H11.2311V9.46222C11.2311 8.23111 10.7078 7.85111 10.0322 7.85111C9.31889 7.85111 8.61889 8.38889 8.61889 9.49333V13.6367H6.21333V5.99445H8.52667V7.05333H8.55778C8.79 6.58333 9.60333 5.78 10.8444 5.78C12.1867 5.78 13.6367 6.57667 13.6367 8.91L13.6356 13.6367Z"
        fill="#0A66C2"
      />
    </g>
    <defs>
      <clipPath id="clip0_34444_3384">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const HeadphoneIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M4.66669 14.5605L4.93335 14.2939C4.97326 14.254 4.99321 14.234 5.00984 14.2169C6.26691 12.9233 6.26691 10.8644 5.00984 9.57084C4.99321 9.55372 4.97326 9.53377 4.93335 9.49386L4.66669 9.2272M11.3334 14.5605L11.0667 14.2939C11.0268 14.254 11.0068 14.234 10.9902 14.2169C9.73313 12.9233 9.73313 10.8644 10.9902 9.57084C11.0068 9.55372 11.0268 9.53377 11.0667 9.49386L11.3334 9.2272M1.67276 9.93432C1.77747 9.9079 1.8871 9.89386 2.00002 9.89386C2.7364 9.89386 3.33335 10.4908 3.33335 11.2272V12.5605C3.33335 13.2969 2.7364 13.8939 2.00002 13.8939C1.26364 13.8939 0.666687 13.2969 0.666687 12.5605V11.2272C0.666687 10.6037 1.0946 10.0802 1.67276 9.93432ZM1.67276 9.93432L1.59774 9.43424C1.07894 5.97553 3.40095 2.73006 6.84194 2.10442C7.60772 1.96519 8.39233 1.96519 9.15811 2.10442C12.5991 2.73006 14.9211 5.97553 14.4023 9.43424L14.3273 9.93432M14.3273 9.93432C14.2226 9.9079 14.1129 9.89386 14 9.89386C13.2636 9.89386 12.6667 10.4908 12.6667 11.2272V12.5605C12.6667 13.2969 13.2636 13.8939 14 13.8939C14.7364 13.8939 15.3334 13.2969 15.3334 12.5605V11.2272C15.3334 10.6037 14.9054 10.0802 14.3273 9.93432Z"
      stroke="#202835"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
);

export const UsersGroupIcon = ({ className, size = 16 }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.3321 13.3334C11.3321 12.2288 9.83967 11.3334 7.99872 11.3334C6.15777 11.3334 4.66539 12.2288 4.66539 13.3334M13.9987 11.3336C13.9987 10.5135 13.176 9.80866 11.9987 9.50004M1.99872 11.3336C1.99872 10.5135 2.82145 9.80866 3.99872 9.50004M11.9987 6.82411C12.4079 6.4579 12.6654 5.92571 12.6654 5.33337C12.6654 4.2288 11.77 3.33337 10.6654 3.33337C10.1532 3.33337 9.68589 3.52594 9.33205 3.84264M3.99872 6.82411C3.58955 6.4579 3.33205 5.92571 3.33205 5.33337C3.33205 4.2288 4.22748 3.33337 5.33205 3.33337C5.84429 3.33337 6.31155 3.52594 6.66539 3.84264M7.99872 9.33338C6.89415 9.33338 5.99872 8.43794 5.99872 7.33337C5.99872 6.2288 6.89415 5.33337 7.99872 5.33337C9.10329 5.33337 9.99872 6.2288 9.99872 7.33337C9.99872 8.43794 9.10329 9.33338 7.99872 9.33338Z"
      stroke="#202835"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon = ({ color = "#202835", className, size = 16 }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill={color}
  >
    <path
      d="M3.87405 13.3634L4.31489 12.7566L3.87405 13.3634ZM3.13661 12.626L3.74337 12.1851L3.13661 12.626ZM13.8634 12.626L13.2566 12.1851L13.8634 12.626ZM13.126 13.3634L12.6851 12.7566L13.126 13.3634ZM13.126 2.63661L12.6851 3.24337L13.126 2.63661ZM13.8634 3.37405L13.2566 3.81489L13.8634 3.37405ZM3.87405 2.63661L4.31489 3.24337L3.87405 2.63661ZM3.13661 3.37405L3.74337 3.81489L3.13661 3.37405ZM6.5 7.25C6.08579 7.25 5.75 7.58579 5.75 8C5.75 8.41421 6.08579 8.75 6.5 8.75V7.25ZM10.5 8.75C10.9142 8.75 11.25 8.41421 11.25 8C11.25 7.58579 10.9142 7.25 10.5 7.25V8.75ZM7.75 10C7.75 10.4142 8.08579 10.75 8.5 10.75C8.91421 10.75 9.25 10.4142 9.25 10H7.75ZM9.25 6C9.25 5.58579 8.91421 5.25 8.5 5.25C8.08579 5.25 7.75 5.58579 7.75 6H9.25ZM8.5 13.25C7.23338 13.25 6.34366 13.249 5.65896 13.1748C4.98829 13.1021 4.60384 12.9666 4.31489 12.7566L3.43321 13.9702C4.02048 14.3968 4.69909 14.5796 5.49739 14.6661C6.28165 14.751 7.2668 14.75 8.5 14.75V13.25ZM1.75 8C1.75 9.2332 1.74897 10.2184 1.83394 11.0026C1.92043 11.8009 2.10317 12.4795 2.52985 13.0668L3.74337 12.1851C3.53344 11.8962 3.39788 11.5117 3.32521 10.841C3.25103 10.1563 3.25 9.26662 3.25 8H1.75ZM4.31489 12.7566C4.09558 12.5973 3.90271 12.4044 3.74337 12.1851L2.52985 13.0668C2.78171 13.4134 3.08656 13.7183 3.43321 13.9702L4.31489 12.7566ZM13.75 8C13.75 9.26662 13.749 10.1563 13.6748 10.841C13.6021 11.5117 13.4666 11.8962 13.2566 12.1851L14.4702 13.0668C14.8968 12.4795 15.0796 11.8009 15.1661 11.0026C15.251 10.2184 15.25 9.2332 15.25 8H13.75ZM8.5 14.75C9.7332 14.75 10.7184 14.751 11.5026 14.6661C12.3009 14.5796 12.9795 14.3968 13.5668 13.9702L12.6851 12.7566C12.3962 12.9666 12.0117 13.1021 11.341 13.1748C10.6563 13.249 9.76662 13.25 8.5 13.25V14.75ZM13.2566 12.1851C13.0973 12.4044 12.9044 12.5973 12.6851 12.7566L13.5668 13.9702C13.9134 13.7183 14.2183 13.4134 14.4702 13.0668L13.2566 12.1851ZM8.5 2.75C9.76662 2.75 10.6563 2.75103 11.341 2.82521C12.0117 2.89788 12.3962 3.03344 12.6851 3.24337L13.5668 2.02985C12.9795 1.60317 12.3009 1.42043 11.5026 1.33394C10.7184 1.24897 9.7332 1.25 8.5 1.25V2.75ZM15.25 8C15.25 6.7668 15.251 5.78165 15.1661 4.99739C15.0796 4.19909 14.8968 3.52048 14.4702 2.93321L13.2566 3.81489C13.4666 4.10384 13.6021 4.48829 13.6748 5.15896C13.749 5.84366 13.75 6.73338 13.75 8H15.25ZM12.6851 3.24337C12.9044 3.40271 13.0973 3.59558 13.2566 3.81489L14.4702 2.93321C14.2183 2.58656 13.9134 2.28171 13.5668 2.02985L12.6851 3.24337ZM8.5 1.25C7.2668 1.25 6.28165 1.24897 5.49739 1.33394C4.69909 1.42043 4.02048 1.60317 3.43321 2.02985L4.31489 3.24337C4.60384 3.03344 4.98829 2.89788 5.65896 2.82521C6.34366 2.75103 7.23338 2.75 8.5 2.75V1.25ZM3.25 8C3.25 6.73338 3.25103 5.84366 3.32521 5.15896C3.39788 4.48829 3.53344 4.10384 3.74337 3.81489L2.52985 2.93321C2.10317 3.52048 1.92043 4.19909 1.83394 4.99739C1.74897 5.78165 1.75 6.7668 1.75 8H3.25ZM3.43321 2.02985C3.08656 2.28171 2.78171 2.58656 2.52985 2.93321L3.74337 3.81489C3.90271 3.59558 4.09558 3.40271 4.31489 3.24337L3.43321 2.02985ZM6.5 8.75H10.5V7.25H6.5V8.75ZM9.25 10V6H7.75V10H9.25Z"
      fill={color}
    />
  </svg>
);

export const EditIcon = ({ color = "#202835", className, size = 16 }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M7.94265 15.85L7.66972 15.1515L7.94265 15.85ZM4.56232 16.4992L4.18732 17.1487H4.18732L4.56232 16.4992ZM3.4343 13.2472L2.69285 13.3601L3.4343 13.2472ZM3.84288 11.0786L4.4924 11.4536L3.84288 11.0786ZM3.35609 12.1096L2.61906 11.9708H2.61906L3.35609 12.1096ZM9.61639 14.4119L10.2659 14.7869L9.61639 14.4119ZM8.96687 15.349L9.45564 15.9179H9.45564L8.96687 15.349ZM7.00825 5.59602L6.35873 5.22102L7.00825 5.59602ZM16.1749 17.6259C16.5891 17.6259 16.9249 17.2901 16.9249 16.8759C16.9249 16.4617 16.5891 16.1259 16.1749 16.1259V17.6259ZM11.1749 16.1259C10.7607 16.1259 10.4249 16.4617 10.4249 16.8759C10.4249 17.2901 10.7607 17.6259 11.1749 17.6259V16.1259ZM12.1322 8.55435L8.96687 14.0369L10.2659 14.7869L13.4313 9.30435L12.1322 8.55435ZM4.4924 11.4536L7.65777 5.97102L6.35873 5.22102L3.19336 10.7036L4.4924 11.4536ZM7.66972 15.1515C6.75236 15.5099 6.13993 15.7472 5.67035 15.8569C5.22037 15.962 5.04714 15.9131 4.93732 15.8496L4.18732 17.1487C4.77122 17.4858 5.39262 17.4622 6.01161 17.3175C6.611 17.1775 7.34187 16.89 8.21558 16.5486L7.66972 15.1515ZM2.69285 13.3601C2.83409 14.2874 2.95052 15.0641 3.12894 15.6532C3.31319 16.2616 3.60342 16.8116 4.18732 17.1487L4.93732 15.8496C4.8275 15.7862 4.69848 15.6607 4.56454 15.2184C4.42476 14.7569 4.32405 14.1079 4.17575 13.1342L2.69285 13.3601ZM3.19336 10.7036C2.92944 11.1607 2.70073 11.5373 2.61906 11.9708L4.09312 12.2485C4.11657 12.1241 4.17734 11.9993 4.4924 11.4536L3.19336 10.7036ZM4.17575 13.1342C4.08088 12.5113 4.06968 12.3729 4.09312 12.2485L2.61906 11.9708C2.5374 12.4042 2.61338 12.8382 2.69285 13.3601L4.17575 13.1342ZM8.96687 14.0369C8.65181 14.5826 8.57412 14.6977 8.47809 14.7802L9.45564 15.9179C9.79018 15.6304 10.002 15.2441 10.2659 14.7869L8.96687 14.0369ZM8.21558 16.5486C8.70723 16.3565 9.1211 16.2053 9.45564 15.9179L8.47809 14.7802C8.38206 14.8627 8.25664 14.9222 7.66972 15.1515L8.21558 16.5486ZM11.1867 5.02545C11.8854 5.42889 12.3434 5.69513 12.6567 5.93693C12.9528 6.16544 13.0273 6.30406 13.0571 6.41539L14.506 6.02716C14.3572 5.47166 14.0021 5.08045 13.5731 4.74941C13.1614 4.43167 12.5987 4.10865 11.9367 3.72642L11.1867 5.02545ZM13.4313 9.30435C13.8135 8.6423 14.1393 8.08122 14.337 7.60018C14.543 7.099 14.6549 6.58266 14.506 6.02716L13.0571 6.41539C13.087 6.52673 13.0918 6.68401 12.9496 7.02996C12.7991 7.39604 12.5357 7.85558 12.1322 8.55435L13.4313 9.30435ZM11.9367 3.72642C11.2746 3.34418 10.7135 3.0184 10.2325 2.82069C9.73132 2.61471 9.21498 2.50281 8.65948 2.65166L9.04771 4.10055C9.15904 4.07071 9.31633 4.0659 9.66227 4.20808C10.0284 4.35854 10.4879 4.62202 11.1867 5.02545L11.9367 3.72642ZM7.65777 5.97102C8.06121 5.27224 8.32744 4.8143 8.56925 4.50096C8.79775 4.20485 8.93638 4.13038 9.04771 4.10055L8.65948 2.65166C8.10398 2.8005 7.71277 3.15558 7.38173 3.58455C7.06399 3.99629 6.74097 4.55897 6.35873 5.22102L7.65777 5.97102ZM13.1568 8.27983L7.38325 4.9465L6.63325 6.24554L12.4068 9.57887L13.1568 8.27983ZM16.1749 16.1259H11.1749V17.6259H16.1749V16.1259Z"
      fill="#202835"
    />
  </svg>
);

export const BuildingIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="24"
    viewBox="0 0 16 13"
    fill="none"
  >
    <path
      d="M1.33463 12.3332H2.66797M2.66797 12.3332H9.33464M2.66797 12.3332V3.13334C2.66797 2.3866 2.66797 2.01296 2.81329 1.72774C2.94112 1.47686 3.14495 1.27303 3.39583 1.1452C3.68105 0.999878 4.05469 0.999878 4.80143 0.999878H7.20143C7.94817 0.999878 8.32102 0.999878 8.60623 1.1452C8.85711 1.27303 9.06162 1.47686 9.18945 1.72774C9.33464 2.01268 9.33464 2.38587 9.33464 3.13115V6.99988M9.33464 12.3332H13.3346M9.33464 12.3332V6.99988M13.3346 12.3332H14.668M13.3346 12.3332V6.99988C13.3346 6.37862 13.3346 6.06815 13.2331 5.82312C13.0977 5.49642 12.8384 5.2367 12.5117 5.10137C12.2667 4.99988 11.9557 4.99988 11.3345 4.99988C10.7132 4.99988 10.4026 4.99988 10.1576 5.10137C9.83085 5.2367 9.57145 5.49642 9.43613 5.82312C9.33464 6.06815 9.33464 6.37862 9.33464 6.99988M4.66797 5.66654H7.33463M4.66797 3.66654H7.33463"
      stroke="#333333"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Update your DashboardIcon component
export const DashboardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="menu-icon"
  >
    <rect
      x="3.51941"
      y="4.02002"
      width="7.035"
      height="4.02"
      rx="2.01"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="3.51941"
      y="11.0552"
      width="7.035"
      height="10.05"
      rx="2.5125"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="13.5685"
      y="4.02002"
      width="7.035"
      height="10.05"
      rx="2.5125"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="13.5685"
      y="17.085"
      width="7.035"
      height="4.02"
      rx="2.01"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const AssignmetnsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="menu-icon"
  >
    <path
      d="M13.4211 9.27915C14.8719 10.172 15.5973 10.6185 15.8407 11.2013C16.0531 11.7097 16.0531 12.2903 15.8407 12.7987C15.5973 13.3815 14.8719 13.828 13.4211 14.7208C11.9702 15.6137 11.2448 16.0602 10.6496 15.9935C10.1303 15.9353 9.65868 15.645 9.35181 15.1948C9 14.6786 9 13.7858 9 12C9 10.2142 9 9.32135 9.35181 8.80519C9.65868 8.35497 10.1303 8.06469 10.6496 8.00652C11.2448 7.93983 11.9702 8.38627 13.4211 9.27915Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M3 12C3 8.25027 3 6.3754 3.95491 5.06107C4.26331 4.6366 4.6366 4.26331 5.06107 3.95491C6.3754 3 8.25027 3 12 3C15.7497 3 17.6246 3 18.9389 3.95491C19.3634 4.26331 19.7367 4.6366 20.0451 5.06107C21 6.3754 21 8.25027 21 12C21 15.7497 21 17.6246 20.0451 18.9389C19.7367 19.3634 19.3634 19.7367 18.9389 20.0451C17.6246 21 15.7497 21 12 21C8.25027 21 6.3754 21 5.06107 20.0451C4.6366 19.7367 4.26331 19.3634 3.95491 18.9389C3 17.6246 3 15.7497 3 12Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export const OrganizationsIcon = ({ style, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    className="menu-icon"
    style={{ fontSize: 24, ...style }}
    {...props}
  >
    <path
      d="M2.00195 19.9999H4.00195M4.00195 19.9999H14.002M4.00195 19.9999V6.20007C4.00195 5.07997 4.00195 4.5195 4.21994 4.09167C4.41169 3.71535 4.71743 3.40961 5.09375 3.21786C5.52157 2.99988 6.08204 2.99988 7.20215 2.99988H10.8022C11.9223 2.99988 12.4815 2.99988 12.9094 3.21786C13.2857 3.40961 13.5924 3.71535 13.7842 4.09167C14.002 4.51908 14.002 5.07887 14.002 6.19679V11.9999M14.002 19.9999H20.002M14.002 19.9999V11.9999M20.002 19.9999H22.002M20.002 19.9999V11.9999C20.002 11.068 20.0019 10.6023 19.8496 10.2347C19.6466 9.74469 19.2576 9.35511 18.7676 9.15212C18.4 8.99988 17.9336 8.99988 17.0017 8.99988C16.0698 8.99988 15.6039 8.99988 15.2363 9.15212C14.7463 9.35511 14.3572 9.74469 14.1542 10.2347C14.002 10.6023 14.002 11.068 14.002 11.9999M7.00195 9.99988H11.002M7.00195 6.99988H11.002"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FormIcon = ({ className, width = 24, height = 24 }) => (
  <svg
    className={`menu-icon ${className || ""}`}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <g clipPath="url(#clip0_34444_3336)">
      <path
        d="M3.99993 6.00005C3.60568 6.00109 3.21514 5.92393 2.8509 5.77306C2.48667 5.62218 2.15597 5.40057 1.87793 5.12105L0.333929 3.74705C0.135812 3.57042 0.0159778 3.32232 0.000787327 3.05733C-0.0144031 2.79234 0.076295 2.53217 0.252929 2.33405C0.429563 2.13594 0.677665 2.0161 0.942654 2.00091C1.20764 1.98572 1.46781 2.07642 1.66593 2.25305L3.25093 3.66705C3.34167 3.76895 3.45229 3.8512 3.57601 3.90874C3.69972 3.96629 3.8339 3.9979 3.97029 4.00165C4.10668 4.0054 4.24239 3.98119 4.36907 3.93053C4.49576 3.87987 4.61074 3.80382 4.70693 3.70705L8.31093 0.276055C8.50472 0.103525 8.75799 0.0130738 9.01723 0.0238058C9.27648 0.0345378 9.5214 0.145613 9.70027 0.33357C9.87914 0.521527 9.97795 0.771649 9.97584 1.03111C9.97372 1.29056 9.87084 1.53904 9.68893 1.72405L6.09993 5.13805C5.8237 5.41267 5.49605 5.63015 5.13572 5.77806C4.77539 5.92597 4.38944 6.0014 3.99993 6.00005ZM23.9999 4.00005C23.9999 3.73484 23.8946 3.48048 23.707 3.29295C23.5195 3.10541 23.2651 3.00005 22.9999 3.00005H12.9999C12.7347 3.00005 12.4804 3.10541 12.2928 3.29295C12.1053 3.48048 11.9999 3.73484 11.9999 4.00005C11.9999 4.26527 12.1053 4.51962 12.2928 4.70716C12.4804 4.8947 12.7347 5.00005 12.9999 5.00005H22.9999C23.2651 5.00005 23.5195 4.8947 23.707 4.70716C23.8946 4.51962 23.9999 4.26527 23.9999 4.00005ZM6.09993 13.1381L9.68893 9.72405C9.7891 9.63487 9.87031 9.52645 9.92772 9.40525C9.98514 9.28404 10.0176 9.15252 10.0231 9.01852C10.0287 8.88452 10.0072 8.75077 9.96002 8.62523C9.91282 8.49969 9.84085 8.38493 9.74839 8.28778C9.65593 8.19062 9.54487 8.11306 9.42183 8.0597C9.29878 8.00635 9.16626 7.97829 9.03214 7.97719C8.89803 7.9761 8.76507 8.00199 8.64117 8.05334C8.51727 8.10468 8.40496 8.18042 8.31093 8.27605L4.71093 11.7071C4.52056 11.8891 4.26732 11.9907 4.00393 11.9907C3.74054 11.9907 3.4873 11.8891 3.29693 11.7071L1.70693 10.1221C1.51833 9.9399 1.26572 9.8391 1.00353 9.84138C0.741331 9.84366 0.490519 9.94883 0.305111 10.1342C0.119703 10.3196 0.0145336 10.5705 0.0122552 10.8327C0.00997675 11.0948 0.110771 11.3475 0.292929 11.5361L1.87793 13.1211C2.4376 13.6809 3.19585 13.9968 3.98743 14C4.77901 14.0031 5.53977 13.6933 6.10393 13.1381H6.09993ZM23.9999 12.0001C23.9999 11.7348 23.8946 11.4805 23.707 11.2929C23.5195 11.1054 23.2651 11.0001 22.9999 11.0001H12.9999C12.7347 11.0001 12.4804 11.1054 12.2928 11.2929C12.1053 11.4805 11.9999 11.7348 11.9999 12.0001C11.9999 12.2653 12.1053 12.5196 12.2928 12.7072C12.4804 12.8947 12.7347 13.0001 12.9999 13.0001H22.9999C23.2651 13.0001 23.5195 12.8947 23.707 12.7072C23.8946 12.5196 23.9999 12.2653 23.9999 12.0001ZM6.09993 21.1381L9.68493 17.7241C9.7851 17.6349 9.86631 17.5265 9.92372 17.4052C9.98114 17.284 10.0136 17.1525 10.0191 17.0185C10.0247 16.8845 10.0032 16.7508 9.95601 16.6252C9.90882 16.4997 9.83685 16.3849 9.74439 16.2878C9.65193 16.1906 9.54087 16.1131 9.41783 16.0597C9.29478 16.0063 9.16226 15.9783 9.02814 15.9772C8.89403 15.9761 8.76107 16.002 8.63717 16.0533C8.51327 16.1047 8.40096 16.1804 8.30693 16.2761L4.70693 19.7071C4.61074 19.8038 4.49576 19.8799 4.36907 19.9305C4.24239 19.9812 4.10668 20.0054 3.97029 20.0016C3.8339 19.9979 3.69972 19.9663 3.57601 19.9087C3.45229 19.8512 3.34167 19.7689 3.25093 19.6671L1.66593 18.2531C1.46781 18.0764 1.20764 17.9857 0.942654 18.0009C0.677665 18.0161 0.429563 18.1359 0.252929 18.3341C0.076295 18.5322 -0.0144031 18.7923 0.000787327 19.0573C0.0159778 19.3223 0.135812 19.5704 0.333929 19.7471L1.87793 21.1211C2.4376 21.6809 3.19585 21.9968 3.98743 22C4.77901 22.0031 5.53977 21.6933 6.10393 21.1381H6.09993ZM23.9999 20.0001C23.9999 19.7348 23.8946 19.4805 23.707 19.2929C23.5195 19.1054 23.2651 19.0001 22.9999 19.0001H12.9999C12.7347 19.0001 12.4804 19.1054 12.2928 19.2929C12.1053 19.4805 11.9999 19.7348 11.9999 20.0001C11.9999 20.2653 12.1053 20.5196 12.2928 20.7072C12.4804 20.8947 12.7347 21.0001 12.9999 21.0001H22.9999C23.2651 21.0001 23.5195 20.8947 23.707 20.7072C23.8946 20.5196 23.9999 20.2653 23.9999 20.0001Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_34444_3336">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
    {/* Add rest of the paths with fill="currentColor" */}
  </svg>
);

export const CampaignsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="menu-icon"
  >
    <path
      d="M16.9981 20C16.9981 18.3431 14.7595 17 11.9981 17C9.23663 17 6.99805 18.3431 6.99805 20M20.9981 17.0004C20.9981 15.7702 19.764 14.7129 17.9981 14.25M2.99805 17.0004C2.99805 15.7702 4.23214 14.7129 5.99805 14.25M17.9981 10.2361C18.6118 9.68679 18.9981 8.8885 18.9981 8C18.9981 6.34315 17.6549 5 15.9981 5C15.2297 5 14.5288 5.28885 13.9981 5.76389M5.99805 10.2361C5.3843 9.68679 4.99805 8.8885 4.99805 8C4.99805 6.34315 6.34119 5 7.99805 5C8.7664 5 9.46729 5.28885 9.99805 5.76389M11.9981 14C10.3412 14 8.99805 12.6569 8.99805 11C8.99805 9.34315 10.3412 8 11.9981 8C13.6549 8 14.9981 9.34315 14.9981 11C14.9981 12.6569 13.6549 14 11.9981 14Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const InterpreterIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="menu-icon"
  >
    <path
      d="M14.9941 18.9998C14.9941 16.7906 12.3079 14.9998 8.99414 14.9998C5.68043 14.9998 2.99414 16.7906 2.99414 18.9998M16.8223 5.17163C17.1937 5.54307 17.4883 5.98402 17.6894 6.46932C17.8904 6.95463 17.994 7.47509 17.994 8.00038C17.994 8.52566 17.8905 9.04473 17.6895 9.53003C17.4884 10.0153 17.1937 10.4568 16.8223 10.8282M18.9941 2.99976C19.6508 3.65636 20.1716 4.43587 20.527 5.29377C20.8823 6.15168 21.066 7.07102 21.066 7.99961C21.066 8.92819 20.8827 9.84791 20.5274 10.7058C20.172 11.5637 19.6508 12.3433 18.9941 12.9999M8.99414 11.9998C6.785 11.9998 4.99414 10.2089 4.99414 7.99976C4.99414 5.79062 6.785 3.99976 8.99414 3.99976C11.2033 3.99976 12.9941 5.79062 12.9941 7.99976C12.9941 10.2089 11.2033 11.9998 8.99414 11.9998Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
  >
    <path
      d="M8 5l5 5-5 5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExportIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M19.2178 7.93844L19.1005 8.67921H19.1005L19.2178 7.93844ZM15.0616 3.78217L14.3208 3.8995V3.8995L15.0616 3.78217ZM5.06107 21.0451L5.50191 20.4383L5.06107 21.0451ZM3.95491 19.9389L4.56168 19.4981L3.95491 19.9389ZM20.0451 19.9389L19.4383 19.4981L20.0451 19.9389ZM18.9389 21.0451L18.4981 20.4383L18.9389 21.0451ZM18.9389 2.95491L19.3798 2.34815L18.9389 2.95491ZM20.0451 4.06107L20.6518 3.62023L20.0451 4.06107ZM5.06107 2.95491L5.50191 3.56168L5.06107 2.95491ZM3.95491 4.06107L4.56168 4.50191L3.95491 4.06107ZM15 2.02893L15.0257 1.27937L15 2.02893ZM20.9711 8L21.7206 7.97432L20.9711 8ZM8 15.25C7.58579 15.25 7.25 15.5858 7.25 16C7.25 16.4142 7.58579 16.75 8 16.75V15.25ZM11 16.75C11.4142 16.75 11.75 16.4142 11.75 16C11.75 15.5858 11.4142 15.25 11 15.25V16.75ZM8 11.25C7.58579 11.25 7.25 11.5858 7.25 12C7.25 12.4142 7.58579 12.75 8 12.75V11.25ZM16 12.75C16.4142 12.75 16.75 12.4142 16.75 12C16.75 11.5858 16.4142 11.25 16 11.25V12.75ZM8 7.25C7.58579 7.25 7.25 7.58579 7.25 8C7.25 8.41421 7.58579 8.75 8 8.75V7.25ZM11 8.75C11.4142 8.75 11.75 8.41421 11.75 8C11.75 7.58579 11.4142 7.25 11 7.25V8.75ZM19.3352 7.19768C17.5166 6.90965 16.0904 5.48339 15.8023 3.66485L14.3208 3.8995C14.7105 6.35988 16.6401 8.28952 19.1005 8.67921L19.3352 7.19768ZM20.25 11V13H21.75V11H20.25ZM3.75 13V11H2.25V13H3.75ZM12 21.25C10.1084 21.25 8.74999 21.249 7.69804 21.135C6.66013 21.0225 6.00992 20.8074 5.50191 20.4383L4.62023 21.6518C5.42656 22.2377 6.37094 22.5 7.53648 22.6263C8.68798 22.751 10.1418 22.75 12 22.75V21.25ZM2.25 13C2.25 14.8582 2.24897 16.312 2.37373 17.4635C2.50001 18.6291 2.76232 19.5734 3.34815 20.3798L4.56168 19.4981C4.19259 18.9901 3.97745 18.3399 3.865 17.302C3.75103 16.25 3.75 14.8916 3.75 13H2.25ZM5.50191 20.4383C5.14111 20.1762 4.82382 19.8589 4.56168 19.4981L3.34815 20.3798C3.70281 20.8679 4.13209 21.2972 4.62023 21.6518L5.50191 20.4383ZM20.25 13C20.25 14.8916 20.249 16.25 20.135 17.302C20.0225 18.3399 19.8074 18.9901 19.4383 19.4981L20.6518 20.3798C21.2377 19.5734 21.5 18.6291 21.6263 17.4635C21.751 16.312 21.75 14.8582 21.75 13H20.25ZM12 22.75C13.8582 22.75 15.312 22.751 16.4635 22.6263C17.6291 22.5 18.5734 22.2377 19.3798 21.6518L18.4981 20.4383C17.9901 20.8074 17.3399 21.0225 16.302 21.135C15.25 21.249 13.8916 21.25 12 21.25V22.75ZM19.4383 19.4981C19.1762 19.8589 18.8589 20.1762 18.4981 20.4383L19.3798 21.6518C19.8679 21.2972 20.2972 20.8679 20.6518 20.3798L19.4383 19.4981ZM18.4981 3.56168C18.8589 3.82382 19.1762 4.14111 19.4383 4.50191L20.6518 3.62023C20.2972 3.13209 19.8679 2.70281 19.3798 2.34815L18.4981 3.56168ZM12 1.25C10.1418 1.25 8.68798 1.24897 7.53648 1.37373C6.37094 1.50001 5.42656 1.76232 4.62023 2.34815L5.50191 3.56168C6.00992 3.19259 6.66013 2.97745 7.69804 2.865C8.74999 2.75103 10.1084 2.75 12 2.75V1.25ZM3.75 11C3.75 9.10843 3.75103 7.74999 3.865 6.69804C3.97745 5.66013 4.19259 5.00992 4.56168 4.50191L3.34815 3.62023C2.76232 4.42656 2.50001 5.37094 2.37373 6.53648C2.24897 7.68798 2.25 9.14184 2.25 11H3.75ZM4.62023 2.34815C4.13209 2.70281 3.70281 3.13209 3.34815 3.62023L4.56168 4.50191C4.82382 4.14111 5.14111 3.82382 5.50191 3.56168L4.62023 2.34815ZM12 2.75C13.1731 2.75 14.1456 2.75009 14.9743 2.77849L15.0257 1.27937C14.1658 1.24991 13.1648 1.25 12 1.25V2.75ZM14.9743 2.77849C16.8292 2.84204 17.7925 3.04907 18.4981 3.56168L19.3798 2.34815C18.2761 1.5463 16.8991 1.34355 15.0257 1.27937L14.9743 2.77849ZM14.25 2.02893C14.25 2.91121 14.2484 3.44215 14.3208 3.8995L15.8023 3.66485C15.7529 3.35298 15.75 2.96617 15.75 2.02892L14.25 2.02893ZM21.75 11C21.75 9.83522 21.7501 8.83424 21.7206 7.97432L20.2215 8.02568C20.2499 8.85445 20.25 9.82692 20.25 11H21.75ZM21.7206 7.97432C21.6564 6.10087 21.4537 4.7239 20.6518 3.62023L19.4383 4.50191C19.9509 5.20746 20.158 6.17075 20.2215 8.02568L21.7206 7.97432ZM20.9711 7.25C20.0338 7.24999 19.647 7.24707 19.3352 7.19768L19.1005 8.67921C19.5579 8.75165 20.0888 8.74999 20.9711 8.75L20.9711 7.25ZM8 16.75H11V15.25H8V16.75ZM8 12.75H16V11.25H8V12.75ZM8 8.75H11V7.25H8V8.75Z"
      fill="#F5F5F5"
    />
  </svg>
);

export const PrintIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18 16.9999C18.9319 16.9999 19.3978 16.9999 19.7654 16.8477C20.2554 16.6447 20.6447 16.2552 20.8477 15.7652C20.9999 15.3976 21 14.9321 21 14.0002V10.1969C21 9.07899 21 8.5192 20.7822 8.0918C20.5905 7.71547 20.2837 7.40973 19.9074 7.21799C19.5058 7.01337 18.9884 7.00082 18 7.00005M18 7.00005C17.9354 7 17.8689 7 17.8002 7H6.2002C6.13139 7 6.06469 7 6 7.00005M18 7.00005L6 7.00005M18 7.00005V6.19691C18 5.07899 18 4.5192 17.7822 4.0918C17.5905 3.71547 17.2837 3.40973 16.9074 3.21799C16.4796 3 15.9203 3 14.8002 3H9.2002C8.08009 3 7.51962 3 7.0918 3.21799C6.71547 3.40973 6.40973 3.71547 6.21799 4.0918C6 4.51962 6 5.08009 6 6.2002V7.00005M6 7.00005C5.01173 7.00082 4.49334 7.01339 4.0918 7.21799C3.71547 7.40973 3.40973 7.71547 3.21799 8.0918C3 8.51962 3 9.08009 3 10.2002V14.0002C3 14.9321 3 15.3976 3.15224 15.7652C3.35523 16.2552 3.74432 16.6447 4.23438 16.8477C4.60192 16.9999 5.06786 16.9999 5.99974 16.9999M10 11H14M9 15H15C15.9319 15 16.3978 15 16.7654 15.1522C17.2554 15.3552 17.6447 15.7443 17.8477 16.2344C17.9999 16.6019 17.9999 17.0681 17.9999 18C17.9999 18.9319 17.9999 19.3978 17.8477 19.7654C17.6447 20.2554 17.2554 20.6447 16.7654 20.8477C16.3978 20.9999 15.9319 21 15 21H9C8.06812 21 7.60192 20.9999 7.23438 20.8477C6.74432 20.6447 6.35523 20.2557 6.15224 19.7656C6 19.3981 6 18.9316 6 17.9997C6 17.0679 6 16.6019 6.15224 16.2344C6.35523 15.7443 6.74432 15.3552 7.23438 15.1522C7.60192 15 8.06812 15 9 15Z"
      stroke="#333333"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
  >
    <path
      d="M15.4309 11.1499L16.1738 11.2533L15.4309 11.1499ZM15.2123 12.7208L15.9551 12.8241L15.2123 12.7208ZM4.78753 12.7208L5.53037 12.6174L4.78753 12.7208ZM4.56892 11.1499L3.82608 11.2533L4.56892 11.1499ZM7.65296 18.6144L7.36137 19.3053L7.65296 18.6144ZM5.39582 15.9673L6.09981 15.7086L5.39582 15.9673ZM14.604 15.9673L15.308 16.2259H15.308L14.604 15.9673ZM12.3469 18.6144L12.0553 17.9234L12.3469 18.6144ZM4.91322 7.92939C4.87404 7.51703 4.508 7.21451 4.09564 7.25369C3.68329 7.29287 3.38077 7.65891 3.41995 8.07127L4.91322 7.92939ZM16.5799 8.07127C16.6191 7.65891 16.3165 7.29287 15.9042 7.25369C15.4918 7.21451 15.1258 7.51703 15.0866 7.92938L16.5799 8.07127ZM16.6666 7.08366C17.0808 7.08366 17.4166 6.74787 17.4166 6.33366C17.4166 5.91945 17.0808 5.58366 16.6666 5.58366V7.08366ZM3.33325 5.58366C2.91904 5.58366 2.58325 5.91945 2.58325 6.33366C2.58325 6.74787 2.91904 7.08366 3.33325 7.08366V5.58366ZM7.58325 15.5003C7.58325 15.9145 7.91904 16.2503 8.33325 16.2503C8.74747 16.2503 9.08325 15.9145 9.08325 15.5003H7.58325ZM9.08325 8.83366C9.08325 8.41945 8.74747 8.08366 8.33325 8.08366C7.91904 8.08366 7.58325 8.41945 7.58325 8.83366H9.08325ZM10.9166 15.5003C10.9166 15.9145 11.2524 16.2503 11.6666 16.2503C12.0808 16.2503 12.4166 15.9145 12.4166 15.5003H10.9166ZM12.4166 8.83366C12.4166 8.41945 12.0808 8.08366 11.6666 8.08366C11.2524 8.08366 10.9166 8.41945 10.9166 8.83366H12.4166ZM13.3333 6.33366V7.08366H14.0833V6.33366H13.3333ZM6.66659 6.33366H5.91659V7.08366H6.66659V6.33366ZM14.6881 11.0465L14.4695 12.6174L15.9551 12.8241L16.1738 11.2533L14.6881 11.0465ZM5.53037 12.6174L5.31176 11.0465L3.82608 11.2533L4.04469 12.8241L5.53037 12.6174ZM9.99992 18.0837C8.71438 18.0837 8.29081 18.0695 7.94455 17.9234L7.36137 19.3053C8.05451 19.5978 8.84913 19.5837 9.99992 19.5837V18.0837ZM4.04469 12.8241C4.27688 14.4925 4.40518 15.4457 4.69183 16.2259L6.09981 15.7086C5.88267 15.1176 5.77338 14.3635 5.53037 12.6174L4.04469 12.8241ZM7.94455 17.9234C7.21648 17.6161 6.52149 16.8563 6.09981 15.7086L4.69183 16.2259C5.21223 17.6423 6.14573 18.7924 7.36137 19.3053L7.94455 17.9234ZM14.4695 12.6174C14.2265 14.3635 14.1172 15.1176 13.9 15.7086L15.308 16.2259C15.5947 15.4457 15.723 14.4925 15.9551 12.8241L14.4695 12.6174ZM9.99992 19.5837C11.1507 19.5837 11.9453 19.5978 12.6385 19.3053L12.0553 17.9234C11.709 18.0695 11.2855 18.0837 9.99992 18.0837V19.5837ZM13.9 15.7086C13.4783 16.8563 12.7834 17.6161 12.0553 17.9234L12.6385 19.3053C13.8541 18.7924 14.7876 17.6423 15.308 16.2259L13.9 15.7086ZM5.31176 11.0465C5.12651 9.71539 4.98875 8.72435 4.91322 7.92939L3.41995 8.07127C3.49929 8.90629 3.6426 9.93491 3.82608 11.2533L5.31176 11.0465ZM16.1738 11.2533C16.3572 9.93491 16.5006 8.90629 16.5799 8.07127L15.0866 7.92938C15.0111 8.72435 14.8733 9.71539 14.6881 11.0465L16.1738 11.2533ZM16.6666 5.58366H3.33325V7.08366H16.6666V5.58366ZM9.08325 15.5003V8.83366H7.58325V15.5003H9.08325ZM12.4166 15.5003V8.83366H10.9166V15.5003H12.4166ZM12.5833 5.50033V6.33366H14.0833V5.50033H12.5833ZM13.3333 5.58366H6.66659V7.08366H13.3333V5.58366ZM7.41658 6.33366V5.50033H5.91659V6.33366H7.41658ZM9.99992 2.91699C11.4267 2.91699 12.5833 4.07359 12.5833 5.50033H14.0833C14.0833 3.24516 12.2551 1.41699 9.99992 1.41699V2.91699ZM9.99992 1.41699C7.74476 1.41699 5.91659 3.24516 5.91659 5.50033H7.41658C7.41658 4.07359 8.57318 2.91699 9.99992 2.91699V1.41699Z"
      fill="#E74C3C"
    />
  </svg>
);

export const MaybeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 40 41"
    fill="none"
  >
    <g clipPath="url(#clip0_35190_29482)">
      <path
        d="M20.0007 30.5007C15.721 30.5007 12.2383 27.018 12.2383 22.7383H9.73828C9.73828 28.3975 14.3415 33.0007 20.0007 33.0007C25.6599 33.0007 30.2632 28.3975 30.2632 22.7383H27.7632C27.7632 27.018 24.2805 30.5007 20.0007 30.5007Z"
        fill="currentColor"
      />
      <path
        d="M12.8697 18.2901C14.7921 18.2901 16.3506 16.7316 16.3506 14.8091C16.3506 12.8866 14.7921 11.3281 12.8697 11.3281C10.9472 11.3281 9.38867 12.8866 9.38867 14.8091C9.38867 16.7316 10.9472 18.2901 12.8697 18.2901Z"
        fill="currentColor"
      />
      <path
        d="M27.1294 18.2901C29.0519 18.2901 30.6104 16.7316 30.6104 14.8091C30.6104 12.8866 29.0519 11.3281 27.1294 11.3281C25.2069 11.3281 23.6484 12.8866 23.6484 14.8091C23.6484 16.7316 25.2069 18.2901 27.1294 18.2901Z"
        fill="currentColor"
      />
      <path
        d="M34.3603 0.5H5.63967C2.53053 0.5 0 3.03053 0 6.13967V34.8604C0 37.9695 2.53053 40.5 5.63967 40.5H34.3604C37.4695 40.5 40 37.9695 40 34.8603V6.13967C40 3.03053 37.4695 0.5 34.3603 0.5ZM37.5 34.8603C37.5 36.5913 36.0913 38 34.3603 38H5.63967C3.90873 38 2.5 36.5913 2.5 34.8603V6.13967C2.5 4.40873 3.90873 3 5.63967 3H34.3604C36.0913 3 37.5001 4.40873 37.5001 6.13967V34.8603H37.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_35190_29482">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const LikelyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 41 41"
    fill="none"
  >
    <g clipPath="url(#clip0_35190_29491)">
      <path
        d="M11.8352 25.0703L10.3386 27.0735C10.4069 27.1235 14.9626 30.4585 20.9941 30.4585C24.0313 30.4585 27.4443 29.6125 30.8465 27.0747L29.3523 25.0703C20.7109 31.5144 12.1941 25.3364 11.8352 25.0703ZM11.7046 19.344L18.6834 14.814L11.7034 10.2852L10.3435 12.3823L14.091 14.814L10.3423 17.2469L11.7046 19.344ZM30.8574 12.3823L29.4976 10.2852L22.5176 14.814L29.4963 19.344L30.8586 17.2469L27.1099 14.814L30.8574 12.3823Z"
        fill="currentColor"
      />
      <path
        d="M34.9604 0.5H6.23977C3.13063 0.5 0.600098 3.03053 0.600098 6.13967V34.8604C0.600098 37.9695 3.13063 40.5 6.23977 40.5H34.9605C38.0696 40.5 40.6001 37.9695 40.6001 34.8603V6.13967C40.6001 3.03053 38.0696 0.5 34.9604 0.5ZM38.1001 34.8603C38.1001 36.5913 36.6914 38 34.9604 38H6.23977C4.50883 38 3.1001 36.5913 3.1001 34.8603V6.13967C3.1001 4.40873 4.50883 3 6.23977 3H34.9605C36.6914 3 38.1002 4.40873 38.1002 6.13967V34.8603H38.1001Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_35190_29491">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.600098 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const DefinitelyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 41 41"
    fill="currentColor"
  >
    <g clipPath="url(#clip0_35190_29498)">
      <path
        d="M20.2012 32.2981C25.1789 32.2981 29.2142 28.2629 29.2142 23.2852H11.1882C11.1882 28.2629 15.2235 32.2981 20.2012 32.2981ZM26.2153 25.7852C25.233 28.1392 22.9073 29.7981 20.2012 29.7981C17.4953 29.7981 15.1694 28.1392 14.1871 25.7852H26.2153Z"
        fill="currentColor"
      />
      <path
        d="M13.0696 18.2901C14.9921 18.2901 16.5506 16.7316 16.5506 14.8091C16.5506 12.8866 14.9921 11.3281 13.0696 11.3281C11.1471 11.3281 9.58862 12.8866 9.58862 14.8091C9.58862 16.7316 11.1471 18.2901 13.0696 18.2901Z"
        fill="currentColor"
      />
      <path
        d="M27.3294 18.2901C29.2519 18.2901 30.8103 16.7316 30.8103 14.8091C30.8103 12.8866 29.2519 11.3281 27.3294 11.3281C25.4069 11.3281 23.8484 12.8866 23.8484 14.8091C23.8484 16.7316 25.4069 18.2901 27.3294 18.2901Z"
        fill="currentColor"
      />
      <path
        d="M34.5603 0.5H5.83962C2.73048 0.5 0.199951 3.03053 0.199951 6.13967V34.8604C0.199951 37.9695 2.73048 40.5 5.83962 40.5H34.5604C37.6694 40.5 40.1999 37.9695 40.1999 34.8603V6.13967C40.1999 3.03053 37.6694 0.5 34.5603 0.5ZM37.6999 34.8603C37.6999 36.5913 36.2912 38 34.5603 38H5.83962C4.10869 38 2.69995 36.5913 2.69995 34.8603V6.13967C2.69995 4.40873 4.1086 3 5.83962 3H34.5604C36.2913 3 37.7 4.40873 37.7 6.13967V34.8603H37.6999Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_35190_29498">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.199951 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const UnlikelyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 41 41"
    fill="currentColor"
  >
    <path
      d="M13.2698 18.2901C15.1923 18.2901 16.7508 16.7316 16.7508 14.8091C16.7508 12.8866 15.1923 11.3281 13.2698 11.3281C11.3473 11.3281 9.78882 12.8866 9.78882 14.8091C9.78882 16.7316 11.3473 18.2901 13.2698 18.2901Z"
      fill="currentColor"
    />
    <path
      d="M27.5296 18.2901C29.4521 18.2901 31.0105 16.7316 31.0105 14.8091C31.0105 12.8866 29.4521 11.3281 27.5296 11.3281C25.6071 11.3281 24.0486 12.8866 24.0486 14.8091C24.0486 16.7316 25.6071 18.2901 27.5296 18.2901Z"
      fill="currentColor"
    />
    <path
      d="M12.9001 26.4141H27.9001V28.9141H12.9001V26.4141Z"
      fill="currentColor"
    />
    <path
      d="M6.03982 40.5H34.7606C37.8696 40.5 40.4001 37.9695 40.4001 34.8603V6.13967C40.4001 3.02988 37.8696 0.5 34.7605 0.5H6.03982C2.93002 0.5 0.400146 3.02988 0.400146 6.13967V34.8604C0.400146 37.9695 2.93002 40.5 6.03982 40.5ZM2.90015 6.13967C2.90015 4.40873 4.30888 3 6.03982 3H34.7606C36.4915 3 37.9002 4.40873 37.9002 6.13967V34.8604C37.9002 36.5913 36.4915 38.0001 34.7606 38.0001H6.03982C4.30888 38.0001 2.90015 36.5913 2.90015 34.8604V6.13967Z"
      fill="currentColor"
    />
  </svg>
);

export const VeryBadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 41 41"
    fill="currentColor"
  >
    <g clipPath="url(#clip0_35190_29466)">
      <path
        d="M12.2367 30.2281C12.5956 29.962 21.1162 23.7865 29.7538 30.2281L31.2479 28.2237C21.0929 20.6474 10.8426 28.1492 10.7401 28.2249L12.2367 30.2281ZM12.0793 19.1758L14.3877 16.8673L16.696 19.1758L18.4636 17.4083L16.1552 15.0997L18.4636 12.791L16.696 11.0234L14.3877 13.332L12.0793 11.0234L10.3118 12.791L12.6202 15.0997L10.3118 17.4083L12.0793 19.1758ZM24.904 19.1758L27.2123 16.8673L29.5207 19.1758L31.2883 17.4083L28.9798 15.0997L31.2883 12.791L29.5207 11.0234L27.2123 13.332L24.904 11.0234L23.1364 12.791L25.4448 15.0997L23.1364 17.4083L24.904 19.1758Z"
        fill="currentColor"
      />
      <path
        d="M6.43972 40.5H35.1605C38.2695 40.5 40.8 37.9695 40.8 34.8603V6.13967C40.8 3.02988 38.2695 0.5 35.1604 0.5H6.43972C3.33058 0.5 0.800049 3.02988 0.800049 6.13967V34.8604C0.800049 37.9695 3.33058 40.5 6.43972 40.5ZM3.30005 6.13967C3.30005 4.40873 4.7087 3 6.43972 3H35.1605C36.8914 3 38.3001 4.40873 38.3001 6.13967V34.8604C38.3001 36.5913 36.8914 38.0001 35.1605 38.0001H6.43972C4.70878 38.0001 3.30005 36.5913 3.30005 34.8604V6.13967Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_35190_29466">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.800049 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const AnanymousIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5.38001 13.8253C4.99575 13.8266 4.61975 13.7138 4.2997 13.5011C3.97965 13.2885 3.72996 12.9856 3.5823 12.6308C3.43464 12.276 3.39566 11.8854 3.4703 11.5085C3.54495 11.1315 3.72985 10.7852 4.00156 10.5135C4.27328 10.2418 4.61956 10.0569 4.99651 9.98227C5.37345 9.90762 5.76407 9.9466 6.11883 10.0943C6.47359 10.2419 6.77651 10.4916 6.98917 10.8117C7.20183 11.1317 7.31466 11.5077 7.31334 11.892C7.31334 12.4047 7.10965 12.8965 6.74708 13.259C6.38451 13.6216 5.89276 13.8253 5.38001 13.8253ZM5.38001 10.952C5.19381 10.9506 5.01142 11.0047 4.85597 11.1071C4.70051 11.2096 4.57899 11.356 4.50682 11.5276C4.43465 11.6992 4.41508 11.8885 4.4506 12.0712C4.48611 12.254 4.57511 12.4221 4.7063 12.5543C4.83749 12.6864 5.00497 12.7766 5.18749 12.8134C5.37001 12.8502 5.55935 12.832 5.7315 12.761C5.90366 12.6901 6.05086 12.5696 6.15445 12.4149C6.25803 12.2602 6.31333 12.0782 6.31334 11.892C6.31335 11.6438 6.21523 11.4057 6.04038 11.2296C5.86554 11.0535 5.62815 10.9537 5.38001 10.952Z"
      fill="#333333"
    />
    <path
      d="M10.1866 13.8253C9.80239 13.8266 9.42639 13.7138 9.10634 13.5011C8.78629 13.2885 8.5366 12.9856 8.38894 12.6308C8.24128 12.276 8.2023 11.8854 8.27694 11.5085C8.35159 11.1315 8.53649 10.7852 8.8082 10.5135C9.07992 10.2418 9.4262 10.0569 9.80315 9.98227C10.1801 9.90762 10.5707 9.9466 10.9255 10.0943C11.2802 10.2419 11.5831 10.4916 11.7958 10.8117C12.0085 11.1317 12.1213 11.5077 12.12 11.892C12.12 12.1459 12.07 12.3973 11.9728 12.6318C11.8757 12.8664 11.7332 13.0795 11.5537 13.259C11.3742 13.4386 11.1611 13.581 10.9265 13.6781C10.6919 13.7753 10.4405 13.8253 10.1866 13.8253ZM10.1866 10.952C10.0005 10.9506 9.81806 11.0047 9.66261 11.1071C9.50715 11.2096 9.38563 11.356 9.31346 11.5276C9.24129 11.6992 9.22172 11.8885 9.25724 12.0712C9.29275 12.254 9.38175 12.4221 9.51294 12.5543C9.64413 12.6864 9.81161 12.7766 9.99413 12.8134C10.1767 12.8502 10.366 12.832 10.5381 12.761C10.7103 12.6901 10.8575 12.5696 10.9611 12.4149C11.0647 12.2602 11.12 12.0782 11.12 11.892C11.12 11.6438 11.0219 11.4057 10.847 11.2296C10.6722 11.0535 10.4348 10.9537 10.1866 10.952Z"
      fill="#333333"
    />
    <path
      d="M8.75323 12.3906H6.81323C6.68062 12.3906 6.55345 12.3379 6.45968 12.2442C6.36591 12.1504 6.31323 12.0232 6.31323 11.8906C6.31323 11.758 6.36591 11.6308 6.45968 11.5371C6.55345 11.4433 6.68062 11.3906 6.81323 11.3906H8.75323C8.88584 11.3906 9.01302 11.4433 9.10679 11.5371C9.20055 11.6308 9.25323 11.758 9.25323 11.8906C9.25323 12.0232 9.20055 12.1504 9.10679 12.2442C9.01302 12.3379 8.88584 12.3906 8.75323 12.3906Z"
      fill="#333333"
    />
    <path
      d="M2.55997 9.84008C2.46601 9.83936 2.37406 9.81287 2.29412 9.7635C2.21419 9.71413 2.14934 9.64377 2.10663 9.56008C2.04932 9.44071 2.0417 9.30348 2.08544 9.17849C2.12919 9.05351 2.22072 8.95099 2.33997 8.89341C4.0612 8.1637 5.91753 7.80698 7.78663 7.84674H7.92663C8.05924 7.84674 8.18642 7.89942 8.28019 7.99319C8.37395 8.08696 8.42663 8.21414 8.42663 8.34674C8.42663 8.47935 8.37395 8.60653 8.28019 8.7003C8.18642 8.79407 8.05924 8.84674 7.92663 8.84674H7.7933C6.07592 8.81911 4.37068 9.13884 2.77997 9.78674C2.71316 9.82499 2.63687 9.84348 2.55997 9.84008Z"
      fill="#333333"
    />
    <path
      d="M13.2798 9.83713C13.2052 9.83928 13.1314 9.82082 13.0665 9.78379C11.4387 9.11127 9.68698 8.79092 7.92651 8.84379C7.79391 8.84379 7.66673 8.79111 7.57296 8.69735C7.47919 8.60358 7.42651 8.4764 7.42651 8.34379C7.42651 8.21118 7.47919 8.08401 7.57296 7.99024C7.66673 7.89647 7.79391 7.84379 7.92651 7.84379C9.84308 7.77721 11.7507 8.1346 13.5132 8.89046C13.6324 8.94804 13.724 9.05056 13.7677 9.17554C13.8114 9.30053 13.8038 9.43776 13.7465 9.55713C13.7028 9.64285 13.6359 9.71455 13.5533 9.76406C13.4708 9.81357 13.3761 9.83889 13.2798 9.83713Z"
      fill="#333333"
    />
    <path
      d="M4.40002 7.51188H4.34003C4.27477 7.50364 4.21177 7.48262 4.15465 7.45C4.09753 7.41738 4.04741 7.37382 4.00715 7.3218C3.9669 7.26977 3.9373 7.21032 3.92006 7.14684C3.90283 7.08337 3.89828 7.01711 3.90669 6.95188C4.00003 6.15188 4.62669 2.17188 6.47336 2.17188H8.00003C8.13263 2.17188 8.25981 2.22455 8.35358 2.31832C8.44735 2.41209 8.50003 2.53927 8.50003 2.67188C8.50003 2.80448 8.44735 2.93166 8.35358 3.02543C8.25981 3.1192 8.13263 3.17188 8.00003 3.17188H6.47336C5.84669 3.17188 5.14003 5.23187 4.90003 7.07854C4.88379 7.19929 4.82402 7.30995 4.73195 7.38974C4.63988 7.46953 4.52185 7.51296 4.40002 7.51188Z"
      fill="#333333"
    />
    <path
      d="M11.44 7.51188C11.3182 7.51296 11.2002 7.46953 11.1081 7.38974C11.016 7.30995 10.9563 7.19929 10.94 7.07854C10.7 5.23187 10 3.17188 9.3667 3.17188H7.8667C7.73409 3.17188 7.60691 3.1192 7.51315 3.02543C7.41938 2.93166 7.3667 2.80448 7.3667 2.67188C7.3667 2.53927 7.41938 2.41209 7.51315 2.31832C7.60691 2.22455 7.73409 2.17188 7.8667 2.17188H9.3667C11.1667 2.17188 11.7867 5.82521 11.9334 6.94521C11.9418 7.01045 11.9372 7.0767 11.92 7.14018C11.9028 7.20366 11.8732 7.26311 11.8329 7.31513C11.7927 7.36715 11.7425 7.41072 11.6854 7.44333C11.6283 7.47595 11.5653 7.49698 11.5 7.50521L11.44 7.51188Z"
      fill="#333333"
    />
  </svg>
);
